import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'info' | 'success' | 'warn' | 'danger';

const TONE_CLASS: Record<BadgeTone, string> = {
  neutral:
    'border-slate-300 bg-slate-100 text-slate-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300',
  info: 'border-sky-300 bg-sky-50 text-sky-800 dark:border-sky-800 dark:bg-sky-950 dark:text-sky-300',
  success:
    'border-emerald-300 bg-emerald-50 text-emerald-800 dark:border-emerald-800 dark:bg-emerald-950 dark:text-emerald-300',
  warn: 'border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-300',
  danger:
    'border-red-300 bg-red-50 text-red-800 dark:border-red-900 dark:bg-red-950 dark:text-red-300',
};

interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  title?: string;
}

export function Badge({ children, tone = 'neutral', title }: BadgeProps) {
  return (
    <span
      title={title}
      className={`inline-flex items-center whitespace-nowrap rounded border px-1.5 py-0.5 text-xs font-medium ${TONE_CLASS[tone]}`}
    >
      {children}
    </span>
  );
}

/** Mau theo trang thai task — dung chung o bang va o khung chi tiet. */
export function statusTone(status: string | null): BadgeTone {
  switch (status) {
    case 'ready':
      return 'success';
    case 'failed':
      return 'danger';
    case 'processing':
      return 'info';
    default:
      return 'neutral';
  }
}

/** Mau theo nguon dap an: noi bo (xanh) vs upstream (cam) — trung y voi bieu do. */
export function sourceTone(source: string | null): BadgeTone {
  switch (source) {
    case 'local':
    case 'canary-local':
      return 'info';
    case 'upstream':
      return 'warn';
    default:
      return 'neutral';
  }
}
